// extracted by mini-css-extract-plugin
export default {"subtitles":"subtitles__eGzZAq","lines":"lines__hflUcH","lastPhrase":"lastPhrase__vCQZMA","waiting":"waiting__o8r36m","dotty":"dotty__ZT9swJ"};